// import the GeoJSON files
import { manoaBuildings } from './MA_Buildings_py.js';
import { manoaBuildings2 } from './MA_Buildings2.js';
// import the building complex properties (FY 23 Data)
import EUIDataJSON from './spreadsheets/EUI Data.json';
// import FY 24 Data
import EUIDataJSON2 from './spreadsheets/EUI Data 2024.json';
// similar to EUIDataJSON but it includes more accurate information about the cooling loops each building is in
import EUICoolingLoops from './spreadsheets/EUI Data Cooling Loops.json';

// used to import bootstrap's css
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import './map.css';

import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
// import Toast's CSS styling
import "react-toastify/dist/ReactToastify.css";

// MapContainer creates the map instance (map data), TileLayer provides the map texture/render (e.g. OpenStreetMap), useMap is used to manipulate map properties using hooks
import { MapContainer, TileLayer, useMap, useMapEvent, Polygon, Polyline, MultiPolygon, Circle, Tooltip, GeoJSON } from 'react-leaflet';
import L from 'leaflet';
// import the legend component for it to be displayed on the map
import Legend from './Legend.jsx';
// import the cooling loops polylines
import CoolingLoops from './CoolingLoops.jsx';

// used to stylize the map (so it doesn't look all over the place)
import 'leaflet/dist/leaflet.css';
// used to directly manipulate DOM elements
import { useEffect, useLayoutEffect, useRef, createContext, useState, use } from "react";
// used to get eui values from different JSX file
import { updateEUI, updateGaugeRangeAndValue } from './GaugeChart.jsx';

import { useAnimate } from 'motion/react';

export const EUIContext = createContext(0);
//export var eui = 0 ;

// used to color the buildings based on EUI value
var EUIColors = [
    {color: "rgb(0, 255, 0)", quality: "Excellent EUI"},
    {color: "rgb(155, 255, 100)", quality: "Good EUI"},
    {color: "#FFFF00", quality: "Average EUI"},
    {color: "rgb(255, 155, 0)", quality: "Poor EUI"},
    {color: "rgb(255, 0, 0)", quality: "Very Poor EUI"},
    {color: "rgb(200, 0, 0)", quality: "Extremely Poor EUI!"},
    {color: "rgb(0, 0, 0)", quality: "Unknown EUI"},
    {color: "#806A5C", quality: "No EUI"},
];



let excludedBuildings = [
   "KAUIOKAHALOA NUI - BUILDING N",
    "KAUIOKAHALOA NUI - BUILDING O",
    "KAUIOKAHALOA NUI - BUILDING P",
    "KAUIOKAHALOA NUI - BUILDING Q",
    "KAUIOKAHALOA NUI MANAGERS OFFICE",
    "MANOA INNOVATION CENTER",
    "MANOA INNOVATION CENTER MECHANICAL BUILDING",
    "HECO SUBSTATION L - LOWER CAMPUS ROAD",
    "SUBSTATION M",
    "KUONOONO 6",
    "LAULIMA 5",
    "MAKAWALU 8",
    "NAHIKU 7",
    "BUS SHELTER - WIST / EVERLY"
];
// used to combine certain building shapes into their complex names
var combinedData;

function getSectionColor(buildingName, getEUIValue, getMaxEUIValue) {
    let sectionColor;
        
        // first test case is for buildings with no EUI data
        if (getEUIValue < 0) {
            sectionColor = (getMaxEUIValue > 0) ? EUIColors[6] : EUIColors[7];
            //console.log(getMaxEUIValue);
        } else if (getEUIValue / getMaxEUIValue < 0.2) {
            // green if the EUI value is very low
            sectionColor = EUIColors[0]; 
            
        } else if (getEUIValue / getMaxEUIValue < 0.4) {
            // light green if the EUI value is low
            sectionColor = EUIColors[1];
        } else if (getEUIValue / getMaxEUIValue < 0.6) {
            // yellow if the EUI value is medium
            sectionColor = EUIColors[2];
        } else if (getEUIValue / getMaxEUIValue < 0.8) {
            // orange if the EUI value is high
            sectionColor = EUIColors[3];
        } else if (getEUIValue / getMaxEUIValue <= 1) {
            // red if the EUI value is very high
            sectionColor = EUIColors[4];
        } else {
            // darker red if the EUI value is off the charts!
            sectionColor = EUIColors[5];
        } 

    return sectionColor;
}

function getStrokeColor(sectionColor) {
    return sectionColor === "rgb(200, 0, 0)" ? "rgb(200, 0, 0)" : sectionColor === "#806A5C" ? "#806A5C" : "rgb(0, 0, 0)";
}

function MapChart({ filteredOptions, setFilteredOptions, filterOptionsRef, fiscalYear, combinedBuildingsData, isCooldown, isCooldownRef, polylineRef1, polylineRef2, polylineRef3, polylineRef4, polylineRef5, buildingInfoRefs, previousColorsRef, selectedBuildingRef, previouslySelectedBuildingRef, getColorForBuilding, previousVisibility, searchTerm, setSearchTerm }) {
    //const prevFilteredOptions = useRef(filteredOptions);
    
    // used to keep track of building's opacity and animating states (Map variables are stored into state variables to properly update them)
    const [opacityMap, setOpacityMap] = useState(new Map());
    const [transitioningBuildings, setTransitioningBuildings] = useState(new Map(filteredOptions.map((o) => [o, true])));
    const [prevFilteredOptions, setPrevFilteredOptions] = useState([]);
    const [selectedName, setSelectedName] = useState(null);
    const [selectedQuality, setSelectedQuality] = useState(null);
    const [booly, setBooly] = useState(true);
    //const [includedBuildings, setIncludedBuildings] = useState(adjustBuildingData(fiscalYear));
    //const [combinedBuildingsData, setCombinedBuildingsData] = useState(combinePolygonsByName(includedBuildings));

    const [isExcellentEUI, setIsExcellentEUI] = useState(false);
    const [isGoodEUI, setIsGoodEUI] = useState(false);
    const [isAverageEUI, setIsAverageEUI] = useState(false);
    const [isPoorEUI, setIsPoorEUI] = useState(false);
    const [isVeryPoorEUI, setIsVeryPoorEUI] = useState(false);
    const [isExtremelyPoorEUI, setIsExtremelyPoorEUI] = useState(false);
    const [isUnknownEUI, setIsUnknownEUI] = useState(false);
    const [isNoEUI, setIsNoEUI] = useState(false);

    const [isLoopA, setIsLoopA] = useState(false);
    const [isLoopB, setIsLoopB] = useState(false);
    const [isLoopC, setIsLoopC] = useState(false);
    const [isLoopD, setIsLoopD] = useState(false);
    const [isLoopQUAD, setIsLoopQUAD] = useState(false);

    const setEUIStates = [setIsExcellentEUI, setIsGoodEUI, setIsAverageEUI, setIsPoorEUI, setIsVeryPoorEUI, setIsExtremelyPoorEUI, setIsUnknownEUI, setIsNoEUI];
    const euiStates = [isExcellentEUI, isGoodEUI, isAverageEUI, isPoorEUI, isVeryPoorEUI, isExtremelyPoorEUI, isUnknownEUI, isNoEUI];
    const setLoopStates = [setIsLoopA, setIsLoopB, setIsLoopC, setIsLoopD, setIsLoopQUAD];
    const loopStates = [isLoopA, isLoopB, isLoopC, isLoopD, isLoopQUAD];

    const [scope, animate] = useAnimate();

    const geoJsonRef = useRef(); 
    const previouzColorzRef = useRef(["#3088ff", "#3088ff"]);

    const isCooldown3 = useRef(false);
    const toastShown3 = useRef(false);

    // 🟢 Update GeoJSON data manually whenever data changes
  useEffect(() => {
    if (!geoJsonRef.current) return;

    const layerGroup = geoJsonRef.current;
    layerGroup.clearLayers();
    layerGroup.addData(combinedBuildingsData);

    // optional: add initial transition style
    // layerGroup.eachLayer((layer) => {
    //   if (layer._path) {
    //     layer._path.removeAttribute('fill-opacity'); // remove any inline fillOpacity to allow CSS to take over
    //     layer._path.classList.add("smooth-transition");
    //     layer._path.style.fillOpacity = 0.25;
    //   }
    // });
  }, [combinedBuildingsData]);

  // 🟡 Animate opacity when filters change
//   useEffect(() => {
//     if (!geoJsonRef.current) return;
//     geoJsonRef.current.eachLayer((layer) => {
//       if (!layer._path) return;
//       layer._path.removeAttribute('fill-opacity'); // remove any inline fillOpacity to allow CSS to take over
//       layer._path.classList.add("smooth-transition");

//       const name = layer.feature?.properties?.COMPLEX_NAME;
//       const isVisible = filteredOptions.includes(name);

//     //   layer._path.style.fillOpacity = isVisible ? 1 : 0.25;
//     //   layer._path.style.strokeOpacity = isVisible ? 1 : 0.25;
//        if (isVisible) {
//         layer._path.classList.remove("building-dimmed");
//         layer._path.classList.add("building-visible");
//        } else {
//         layer._path.classList.remove("building-visible");
//         layer._path.classList.add("building-dimmed");
//         console.log("filtered options: ", isVisible);
//        }
//     });
//   }, [filteredOptions]);

// used to animate the colors of the building via anytime the data changes
  useEffect(() => {
    if (!geoJsonRef.current) return;
    //const layers = [];
    geoJsonRef.current.eachLayer((layer) => {
        const path = layer._path;
        if (!path)  return;
        
        

        // path.classList.remove('smooth-transition');
        // path.classList.add("smooth-fill");
        const name = layer.feature?.properties?.COMPLEX_NAME;
        const quality = layer.feature?.properties?.EUI_QUALITY;

        // if (selectedQuality !== null) {
        //     if (selectedQuality === quality) {
        //         // layer._path.classList.remove("building-dimmed");
        //         layer._path.style.transition = "fill-opacity 1s ease, stroke-opacity 1s ease";
        //         layer._path.style.fillOpacity = 1;
        //         layer._path.style.strokeOpacity = 1;
        //         //layer._path.classList.add('building-visible');
        //     } else {
        //         // layer._path.classList.remove("building-visible");
        //         // layer._path.classList.add("semi-visible");
        //         layer._path.style.transition = "fill-opacity 1s ease, stroke-opacity 1s ease";
        //         layer._path.style.fillOpacity = 0.25;
        //         layer._path.style.strokeOpacity = 0.25;
        //         layer._path.classList.remove("building-visible");
        //         layer._path.classList.add('building-dimmed');
        //     }
        // } else {
        //     layer._path.classList.remove("building-dimmed");
        //     layer._path.classList.add("building-visible");
        // }

        // used to animate the building colors (better to use it after you initialize the previous colors)
        const newColor = getColorForBuilding(quality);
        
        // if (new Set(previousColorsRef.current.values()).size === 1) {
        //     console.log("why you crimosn?");
        //     previousColorsRef.current.set(name, newColor);
        // }

        if (fiscalYear === 2023) {
            // assign previous colors to the building shapes before the color animation
            // console.log(previousColorsRef.current);
            
            // update fill, stroke, and stroke-width properties to the previous values before animating to the new/current ones
            layer._path.style.fill = previousColorsRef.current.get(name);
            
            layer._path.style.stroke = getStrokeColor(layer._path.style.fill);
            layer._path.style.strokeWidth = previousColorsRef.current.get(name) === "rgb(200, 0, 0)" || previousColorsRef.current.get(name) === "#806A5C" ? 2 : 0.1; 
            // perform fill color animation
            switch (newColor) {
                case "rgb(0, 255, 0)":
                    layer._path.classList.add('green-fill');
                    break;
                case "rgb(155, 255, 100)":
                    layer._path.classList.add('light-green-fill');
                    break;
                case "#FFFF00":
                    layer._path.classList.add('yellow-fill');
                    break;
                case "rgb(255, 155, 0)":
                    layer._path.classList.add('orange-fill');
                    break;
                case "rgb(255, 0, 0)":
                    layer._path.classList.add('red-fill');
                    break;
                case "rgb(200, 0, 0)":
                    layer._path.classList.add('crimson-fill');
                    break;
                case "#806A5C":
                    layer._path.classList.add('brown-fill');
                    break;
                default:
                    layer._path.classList.add('black-fill');
            }
           
            // assign current colors to previous colors after animation finished 
            setTimeout(() => {
                previousColorsRef.current.set(name, newColor);
                
                // previouzColorzRef.current[1] = "blue";
            }, 2000);
            
        } else if (fiscalYear === 2024) {
            layer._path.style.fill = previousColorsRef.current.get(name);
            layer._path.style.stroke = getStrokeColor(layer._path.style.fill);
            layer._path.style.strokeWidth = previousColorsRef.current.get(name) === "rgb(200, 0, 0)" || previousColorsRef.current.get(name) === "#806A5C" ? 2 : 0.1; 
            switch (newColor) {
                case "rgb(0, 255, 0)":
                    layer._path.classList.add('green-fill');
                    break;
                case "rgb(155, 255, 100)":
                    layer._path.classList.add('light-green-fill');
                    break;
                case "#FFFF00":
                    layer._path.classList.add('yellow-fill');
                    break;
                case "rgb(255, 155, 0)":
                    layer._path.classList.add('orange-fill');
                    break;
                case "rgb(255, 0, 0)":
                    layer._path.classList.add('red-fill');
                    break;
                case "rgb(200, 0, 0)":
                    layer._path.classList.add('crimson-fill');
                    break;
                case "#806A5C":
                    layer._path.classList.add('brown-fill');
                    break;
                default:
                    layer._path.classList.add('black-fill');
            }
            setTimeout(() => {
                previousColorsRef.current.set(name, newColor);
                // previouzColorzRef.current[1] = "greenyellow";
            }, 2000);
        } else {
            layer._path.style.fill = previousColorsRef.current.get(name);
            layer._path.style.stroke = getStrokeColor(layer._path.style.fill);
            layer._path.style.strokeWidth = previousColorsRef.current.get(name) === "rgb(200, 0, 0)" || previousColorsRef.current.get(name) === "#806A5C" ? 2 : 0.1; 
            switch (newColor) {
                case "rgb(0, 255, 0)":
                    layer._path.classList.add('green-fill');
                    break;
                case "rgb(155, 255, 100)":
                    layer._path.classList.add('light-green-fill');
                    break;
                case "#FFFF00":
                    layer._path.classList.add('yellow-fill');
                    break;
                case "rgb(255, 155, 0)":
                    layer._path.classList.add('orange-fill');
                    break;
                case "rgb(255, 0, 0)":
                    layer._path.classList.add('red-fill');
                    break;
                case "rgb(200, 0, 0)":
                    layer._path.classList.add('crimson-fill');
                    break;
                case "#806A5C":
                    layer._path.classList.add('brown-fill');
                    break;
                default:
                    layer._path.classList.add('black-fill');
            }
            setTimeout(() => {
                previousColorsRef.current.set(name, newColor);
                // previouzColorzRef.current[1] = "orange";
            }, 2000);
        }
        //layers.push(layer);
        //console.log(layer._path.style.fill);
        // console.log(yearRef.current, fiscalYear);
        
    });
    console.log("legend option selected:", selectedQuality);
    // requestAnimationFrame(() => {
        // layers.forEach(layer => {
            
            
        // });
    // });
  }, [getColorForBuilding, selectedQuality, fiscalYear]);


  // opacity animation when filteredOptions changes
  useEffect(() => {
    if (!geoJsonRef.current) return;

    geoJsonRef.current.eachLayer((layer) => {
        const getBuildingName = layer.feature?.properties?.COMPLEX_NAME;
        const getQuality = layer.feature?.properties?.EUI_QUALITY;
        const getCoolingLoop = layer.feature?.properties?.COOLING_LOOP;
        const path = layer._path;

        if (!path)  return;

        //path.classList.remove('fill-opacity');
        path.classList.add("smooth-transition");
        
        // const isSelected = selectedName === getBuildingName;
        
        // const notSelected = selectedName === null;
        // console.log("name: ", getBuildingName, "fillOpacity: ", notSelected ? 1 : isSelected ? 1 : 0.25);
        // path.style.fillOpacity = notSelected ? 1 : isSelected ? 1 : 0.25;
        // path.style.strokeOpacity = notSelected ? 1 : isSelected ? 1 : 0.25;

        // if (notSelected) {
        //     path.classList.remove("building-dimmed");
        //     path.classList.add("building-visible");
        // } else {
        //     if (isSelected) {
        //         path.classList.remove("building-dimmed");
        //         path.classList.add("building-visible");
        //     } else {
        //         path.classList.remove("building-visible");
        //         path.classList.add("building-dimmed");
        //     }
            
        // }

    // const isSelectedBuilding = selectedName === null || selectedName === getBuildingName;
    // const isSelectedQuality = !selectedQuality || getQuality === selectedQuality;

    const matchesSearch = filteredOptions.includes(getBuildingName);
    const matchesQuality = !selectedQuality || getQuality === selectedQuality || getCoolingLoop === selectedQuality;
    const matchesSelection = !selectedName || selectedName === getBuildingName;

    const isVisible = (matchesSearch && matchesQuality && matchesSelection);

    // let isVisible = false;

    // if (selectedName === null && filteredOptions.length === 1) {
    //     setSearchTerm("");
    // } 
    // if (filteredOptions.length > 0) {
        
    //      isVisible = filteredOptions.includes(getBuildingName);
        
    // }
    // if (selectedName) {
    //     isVisible = selectedName === getBuildingName;
    //     // if (filteredOptions.length > 0) {
    //     //     setSelectedName(null);
    //     // }
    //     //if (filteredOptions.length === 1) setSelectedName(null);
    // } else if (selectedQuality) {
    //     // OR operator to include the labels from the 2nd legend as a selectable
    //     isVisible = (getQuality === selectedQuality || getCoolingLoop === selectedQuality) && filteredOptions.includes(getBuildingName);
    // } 

    

    // if (isCooldown3) {
    //      if (!toastShown3) {
    //             console.log("please show up");
    //             toast.warn(<>Please wait a little.</>, 
    //                             { 
    //                                 position: 'top-center',
    //                                 autoClose: 1000, 
    //                                 onClose: () => {
    //                                     setToastShown3(false);
    //                                 }
    //                             });
    //                             // toast shown status is set to true, false 1 second after it shows up
    //                             setToastShown3(true);
                            
    //                         return;
    //           }
    // } else {
        //path.classList.remove("smooth-transition");
        if (isVisible) {
            // path.classList.remove("building-dimmed");
            // path.classList.add("building-visible");
            path.style.transition = "fill-opacity 1s ease, stroke-opacity 1s ease";
            path.style.fillOpacity = 1;
            path.style.strokeOpacity = 1;
        } else {
            // path.classList.remove("building-visible");
            // path.classList.add("building-dimmed");
            path.style.transition = "fill-opacity 1s ease, stroke-opacity 1s ease";
            path.style.fillOpacity = 0.25;
            path.style.strokeOpacity = 0.25;
        }
        
    // }
    // setIsCooldown3(true);
    //     setToastShown3(false);
   
    });
    // setIsCooldown3(true);
    //     setToastShown3(false);
    // setTimeout(() => {
    //           setIsCooldown3(false);
    //           setToastShown3(false);
    //         }, 4000);
  }, [filteredOptions, selectedQuality, selectedName, fiscalYear, isCooldown3, toastShown3]);

  useEffect(() => {
    setSelectedName(null);
    // console.log("options updated:", filteredOptions);
    filteredOptionsRef.current = filteredOptions;
  }, [filteredOptions]);

  const boolyRef3 = useRef(false);

  useEffect(() => {
    boolyRef3.current = true;
  }, [fiscalYear]);

//     useEffect(() => {
//   if (!geoJsonRef.current) return;

//   geoJsonRef.current.eachLayer((layer) => {
//     const el = layer.getElement?.();
//     const name = layer.feature?.properties?.COMPLEX_NAME;

//     const eui = layer.feature?.properties?.euiValue;
//     const maxEUI = layer.feature?.properties?.maxEUIValue;
//     const newColor = getSectionColor(eui, maxEUI).color;

//     const prevColor = previousColorsRef.current.get(name);

//     if (el) {
// //         el.removeAttribute('fill'); // remove Leaflet's SVG attribute
// // el.classList.add('building-fill');
// // el.style.opacity = 0.5;
// // void el.offsetWidth;
// // el.style.opacity = 1;


// //el.setAttribute('fill', newColor);
// // Animate to new color
// //animate(el, { fill: newColor }, { duration: 1 });

//     }
//     //console.log(el.outerHTML);

//     if (el && newColor !== prevColor) {
//         el.classList.add('building-fill');
//         console.log("sdkhgfsdfhgsdfg");
//         el.style.fill = prevColor;
//         animate(el, { fill: newColor }, { duration: 1 });
//         previousColorsRef.current.set(name, newColor);

//         el.classList.remove('building-fill');
//     }
// //     layer.getElement().style.transition = "fill 1s ease, stroke 1s ease";

// //     if (!previousColorsRef.current.has(name)) {
// //       // 🆕 New building — don’t animate, just apply color
// //       if (el) { 
// //         layer.getElement().style.fill = newColor;
// //         layer.getElement().style.fill = newColor;
// //       }
// //     } else if (newColor !== prevColor && el) {
// //       // Force the starting fill into the style so Motion can animate it
// //   layer.getElement().style.fill = prevColor;
// //   el.style.fill = prevColor;
// //   console.log(el.style.fill);

// //   // Animate from prev → new
// //   //animate(el, { fill: newColor }, { duration: 1 }); 

// //   // Update the ref
// //   previousColorsRef.current.set(name, newColor);
// //     }

//     // 📝 Update the ref so it's ready for next change
//     //previousColorsRef.current.set(name, newColor);
//   });
// }, [fiscalYear, combinedBuildingsData]);



    const buildingLayersRef = useRef(new Map()); // let's you control the reference of individual buildings instead of the whole leaflet Map (uses a different kind of Map)
    const activeBuildingRef = useRef(null); // stores currently toggled building name, or null if none
    const activeGroupRef = useRef(null);
    const boolyRef = useRef(false);
    const boolyRef2 = useRef(true);

    // used whenever these useState variables don't update in onEachFeature()
    const filteredOptionsRef = useRef(filteredOptions);
    const euiStatesRef = useRef(euiStates);
    const loopStatesRef = useRef(loopStates);

    const hasInitializedRef = useRef(false);

    useEffect(() => {
        euiStatesRef.current = euiStates;
        loopStatesRef.current = loopStates;
    }, [euiStates, loopStates]);

    // const polylineRef1 = useRef(null);
    // const polylineRef2 = useRef(null);
    // const polylineRef3 = useRef(null);
    // const polylineRef4 = useRef(null);
    // const polylineRef5 = useRef(null);

    

    const buildingLayerRefs = {
        "Excellent EUI": useRef(new Map()),
        "Good EUI": useRef(new Map()),
        "Average EUI": useRef(new Map()),
        "Poor EUI": useRef(new Map()),
        "Very Poor EUI": useRef(new Map()),
        "Extremely Poor EUI!": useRef(new Map()),
        "Unknown EUI": useRef(new Map()),
        "No EUI": useRef(new Map())
    };


    const centerCoordinates = [21.299409807445386, -157.81592241066653];
    const zoomLevel = 15.75;

    

    function selectedLoopA(options = filteredOptions) {
        return options.includes("SAKAMAKI HALL") || options.includes("ART BUILDING") || options.includes("UNIVERSITY HEALTH SERVICES") || options.includes("WATANABE HALL") || options.includes("HOLMES HALL");
    }

    function selectedLoopC(options = filteredOptions) {
        return options.includes("MOORE HALL") || options.includes("AGRICULTURAL ENGINEERING INSTITUTE") || options.includes("SHERMAN LABORATORY") || options.includes("ST. JOHN PLANT SCIENCE LABORATORY 1 AND 2") || options.includes("BIOMEDICAL SCIENCES BUILDING");
    }

    function selectedLoopD(options = filteredOptions) {
        return options.includes("WEBSTER HALL") || options.includes("SPALDING HALL") || options.includes("EDMONDSON HALL");
    }

    function selectedLoopQUAD(options = filteredOptions) {
        return options.includes("SAUNDERS HALL") || options.includes("ARCHITECTURE BUILDING") || options.includes("GEORGE HALL") || options.includes("CRAWFORD HALL") || options.includes("HAWAII HALL") || options.includes("QUADRANGLE LOOP BUILDING") || options.includes("GARTLEY HALL") || options.includes("DEAN HALL");
    }

    function selectedLoopB(options = filteredOptions) {
        return options.includes("HAMILTON LIBRARY") || options.includes("BILGER HALL AND ADDITION") || options.includes("KENNEDY THEATRE");
    }

    // const previousVisibility = useRef(new Map());

function applyVisibilityClass(ref, id, isVisible) {
  const el = ref.current;
  if (!el) return;

  const prev = previousVisibility.current.get(id);
  if (prev === isVisible) return; // 🛑 Skip if no change

  previousVisibility.current.set(id, isVisible);

  ref.current.forEach((path) => {
    
    const currentClass = path.classList.contains('building-visible') ? 'visible'
                   : path.classList.contains('building-dimmed') ? 'dimmed'
                   : 'none';
console.log("exit: ", isVisible, currentClass);
if ((isVisible && currentClass === 'visible') || (!isVisible && currentClass === 'dimmed')) {
    
  return; // No change → skip
}
// if (!isVisible) {
//     return;
// }

  path.classList.remove('building-visible', 'building-dimmed');
  //void el.offsetWidth;
  path.classList.add(isVisible ? 'building-visible' : 'building-dimmed');
  });
  
};




    useEffect(() => {
        
  if (!polylineRef1.current || !polylineRef2.current || !polylineRef3.current || !polylineRef4.current || !polylineRef5.current) return;
const loopAVisible = selectedLoopA();
const loopCVisible = selectedLoopC();
const loopDVisible = selectedLoopD();
const loopQUADVisible = selectedLoopQUAD();
const loopBVisible = selectedLoopB();
// console.log(polylineRef1.current)
// console.log(polylineRef2.current)
// console.log(polylineRef3.current)
// console.log(polylineRef4.current)
        console.log(loopAVisible);
  applyVisibilityClass(polylineRef1, 'A', loopAVisible);
  applyVisibilityClass(polylineRef2, 'C', loopCVisible);
  applyVisibilityClass(polylineRef3, 'D', loopDVisible);
  applyVisibilityClass(polylineRef4, 'QUAD', loopQUADVisible);
  applyVisibilityClass(polylineRef5, 'B', loopBVisible);
        console.log(loopAVisible, loopBVisible, loopCVisible, loopDVisible, loopQUADVisible);
        
  if (
    selectedName !== null &&
    filteredOptions.includes(selectedName)
  ) {
    // console.log(previouslySelectedBuildingRef.current);
    previouslySelectedBuildingRef.current = selectedName;
    // console.log(previouslySelectedBuildingRef.current);
  }
  console.log(euiStates.every(es => es === false) && loopStates.every(ls => ls === false));
  if (euiStates.every(es => es === false) && loopStates.every(ls => ls === false)) {
    previouslySelectedBuildingRef.current = null;
    // console.log(previouslySelectedBuildingRef.current);
  } else {

  }

  
}, [filteredOptions, selectedName, euiStates, loopStates]);


    const euiLabels = [
        "Excellent EUI",
        "Good EUI",
        "Average EUI",
        "Poor EUI",
        "Very Poor EUI",
        "Extremely Poor EUI!",
        "Unknown EUI",
        "No EUI",
    ];

    const loopLabels = ["A", "B", "C", "D", "QUAD"]
    const activeIndexRef = useRef([-1, -1]);
    
    // used to update the selected quality on the legend
    useEffect(() => {
        const activeIndex = euiStates.findIndex(state => state);
        
        const activeIndex2 = loopStates.findIndex(state => state);
        activeIndexRef.current[0] = activeIndex;
        activeIndexRef.current[1] = activeIndex2;
        // legend component should take care of this but use this if/else in case if updating states don't work
        if (activeIndex !== -1) setEUIStates[activeIndex](true);
        else setEUIStates.forEach(def => def(false));
        if (activeIndex2 !== -1) setLoopStates[activeIndex2](true);
        else setLoopStates.forEach(def => def(false));
        // console.log("E state status: ", euiStates[0], "L state status: ", loopStates[4]);

        setSelectedQuality(activeIndex !== -1 ? euiLabels[activeIndex] : activeIndex2 !== -1 ? loopLabels[activeIndex2] : null);
    }, [euiStates, loopStates, selectedQuality]);

    const areArraysShallowEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((item, index) => item === arr2[index]);
    };

    // used to update the list based on the selected EUI Quality
    useEffect(() => {
        //if (!hasInitializedRef.current || !filterOptionsRef.current?.length) return;

        const euiLabels = [
            "Excellent EUI", "Good EUI", "Average EUI", "Poor EUI",
            "Very Poor EUI", "Extremely Poor EUI!", "Unknown EUI", "No EUI"
        ];

        const loopLabels = ["A", "B", "C", "D", "QUAD"];

        const activeIndex = euiStates.findIndex(state => state);
        const activeIndex2 = loopStates.findIndex(state => state);
        
        let filtered;
        
        const targetLabel = euiLabels[activeIndex];
        const targetLabel2 = loopLabels[activeIndex2];

        if (activeIndex !== -1 && activeIndex2 !== -1) {

            filtered = filterOptionsRef.current.filter(option => {
                const layer = buildingLayersRef.current.get(option);
                return layer?.feature?.properties?.EUI_QUALITY === targetLabel || layer?.feature?.properties?.COOLING_LOOP === targetLabel2;
            });
        } else if (activeIndex !== -1) {
            
            // setLoopStates[0](false);
            // setLoopStates[1](false);
            // setLoopStates[2](false);
            // setLoopStates[3](false);
            // setLoopStates[4](false);

            
            filtered = filterOptionsRef.current.filter(option => {
                const layer = buildingLayersRef.current.get(option);
                return layer?.feature?.properties?.EUI_QUALITY === targetLabel;
            }); 
        
            console.log(activeIndex);
            
            // timeout = setTimeout(() => {
                
            //     //setFilteredOptions(filteredOptionsRef.current);
            // }, 50);
            
            // boolyRef.current = true;   
        } else if (activeIndex2 !== -1) {
            // setEUIStates[0](false);
            // setEUIStates[1](false);
            // setEUIStates[2](false);
            // setEUIStates[3](false);
            // setEUIStates[4](false);
            // setEUIStates[5](false);
            // setEUIStates[6](false);
            // setEUIStates[7](false);

            
            filtered = filterOptionsRef.current.filter(option => {
                const layer = buildingLayersRef.current.get(option);
                return layer?.feature?.properties?.COOLING_LOOP === targetLabel2;
            }); 
        } else {
            filtered = filterOptionsRef.current;
            filterOptionsRef.current = filtered;
        }

        // without this, "Maximum Update Depth Exceeded" Error will occur AND the needle animation won't render properly
        if (filtered && !areArraysShallowEqual(filtered, filteredOptions)) {
            setFilteredOptions(filtered);
            //filterOptionsRef.current = filtered;
        }
        // return () => clearTimeout(timeout);
        //return () => {}; // explicit cleanup to silence React's warning tracker
    }, [euiStates, loopStates]);


//     useEffect(() => {
//   if (boolyRef.current) {
//     boolyRef.current = false;
//     console.log('Cleared selected building. Resetting boolyRef to false.');

//   }
  
// }, [selectedBuildingRef, filteredOptions]);


    // function selectedLoopA(options = filteredOptions) {
    //     return options.includes("SAKAMAKI HALL") || options.includes("ART BUILDING") || options.includes("UNIVERSITY HEALTH SERVICES") || options.includes("WATANABE HALL") || options.includes("HOLMES HALL");
    // }
    //console.log(selectedLoopA() ? 1 : 0.25);

    //console.log(combinedData);
    // used to keep track of building's previous opacity 
    const previousOpacity = new Map();  
    // used to keep track of building opacity animation states
    const previousOpacityAnimation = new Map(filteredOptions.map((o) => [o, true])); 
    // 
    //const previousOpacityAnimationStates = new Map(filteredOptions.map((o) => [o, true]));
    //console.log(previousOpacityAnimation);

    function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3); // Easing formula
    }
    
    // used to animate the fill opacity and strok opacity (since stroke animates faster than fill)
    function animateOpacity(layer, start, end, name, fillDuration = 300, strokeDuration = 1200) {
        let startTime = null;

        function animateFill(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / fillDuration, 1);
            const easedProgress = easeOutCubic(progress);
            const newOpacity = start + (end - start) * easedProgress;

            layer.setStyle({
                fillOpacity: newOpacity,
                //color: strokeColor, // Overall opacity
                //weight: layer.options.weight !== EUIColors[5] ? layer.options.weight === "#806A5C" ? 2 : 0.1 : 2.5,  // 🔥 Ensure stroke color updates properly
            });

            if (progress < 1) {
                previousOpacityAnimation.set(name, false);
                setTransitioningBuildings(previousOpacityAnimation);
                requestAnimationFrame(animateFill);
            } else {
                previousOpacityAnimation.set(name, true);
                setTransitioningBuildings(previousOpacityAnimation);
            }
        }
        function animateStroke(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / strokeDuration, 1);
            const newOpacity = start + (end - start) * progress;

            layer.setStyle({
                opacity: newOpacity,
                //color: strokeColor, // Overall opacity
                //weight: layer.options.weight !== EUIColors[5] ? layer.options.weight === "#806A5C" ? 2 : 0.1 : 2.5,  // 🔥 Ensure stroke color updates properly
            });

            if (progress < 1) {
                previousOpacityAnimation.set(name, false);
                setTransitioningBuildings(previousOpacityAnimation);
                requestAnimationFrame(animateStroke);
            } else {
                previousOpacityAnimation.set(name, true);
                setTransitioningBuildings(previousOpacityAnimation);
            }
        }
        // 🔥 Ensure starting opacity is applied first 
        layer.setStyle({ fillOpacity: start }); // ✅ Preserve color & apply initial opacity (w/o it animation on't be smooth)

        // animate both the fill and stroke opacities
        requestAnimationFrame(animateFill);
        requestAnimationFrame(animateStroke);
    }

    function resetFocusState() {
        activeBuildingRef.current = null;
        activeGroupRef.current = null;
    }

    // function handleMapClick() {
    //     //if (isCooldownRef.current) return;

    //     // Defer state reset to next tick
    //     // requestAnimationFrame(() => {
    //         // activeBuildingRef.current = null;
    //         // activeGroupRef.current = null;

    //         buildingLayersRef.current.forEach((otherLayer, otherName) => {
    //         // animateOpacity(otherLayer, 0.25, 1, otherName);
    //         previousOpacity.set(otherName, 1);
    //         });

    //         polylineRef1.current.classList.remove("building-dimmed");
    //         polylineRef1.current.classList.add("building-visible");
    //         polylineRef2.current.classList.remove("building-dimmed");
    //         polylineRef2.current.classList.add("building-visible");
    //         polylineRef3.current.classList.remove("building-dimmed");
    //         polylineRef3.current.classList.add("building-visible");
    //         polylineRef4.current.classList.remove("building-dimmed");
    //         polylineRef4.current.classList.add("building-visible");
    //         polylineRef5.current.classList.remove("building-dimmed");
    //         polylineRef5.current.classList.add("building-visible");

    //         setOpacityMap(new Map(previousOpacity));
    //     // });
    // }

    const applyOpacityTransition = (group, booleanFunction) => {
        //group?.eachLayer(layer => { (2 layers)
            // use path instead of layer, why?
            group.forEach((path) => {
                console.log(booleanFunction);
                if (booleanFunction) {
                    // console.log("sdf");
                    path.classList.remove("building-dimmed");
                    path.classList.add("building-visible");
                } else {
                    path.classList.remove("building-visible");
                    path.classList.add("building-dimmed");
                }
            }); 
        //});
    };

    // handles all building shapes' appearance, animation, and functionality (felt like making a separate function just to make the GeoJSON component look cleaner)
    // onEachFeature itself doesn't take in 3 parameters, so I created one that accepts filteredOptions as the third default parameter
    function onEachFeature2(feature, layer, options = filteredOptions) {
        //let id = feature.id;
        //console.log(combinedData.features.reduce((acc, feature) => { acc.push(feature.properties.PROPER_NAME); return acc; }, []));
        //console.log(feature.properties.PROPER_NAME);
        // gets the building properties
        let getEUIValue = feature.properties.euiValue;
        //if (feature.properties.COOLING_LOOP !== '') console.log(getEUIValue);
        let getMaxEUIValue = feature.properties.maxEUIValue;
        // use cooling loop name if it exists, complex name otherwise feature.properties.COOLING_LOOP === "" || feature.properties.COOLING_LOOP === "Cooling Loop B" ? feature.properties.COMPLEX_NAME : feature.properties.COOLING_LOOP;
        let getBuildingName = feature.properties.COMPLEX_NAME;
        let getBuildingGroup = feature.properties.COOLING_LOOP;
        let getBuildingType = feature.properties.buildingType;
        let getBuildingColor = feature.properties.EUI_Color;
        // get the individual building names from the building complex or cooling loop
        let getBuildingsList = feature.names;
        //console.log(getBuildingsList);
        //console.log(getBuildingName, getEUIValue, getMaxEUIValue);
        // if (buildingInfoRefs) {
        //     buildingInfoRefs[0].current = feature.properties.maxEUIValue;
        //     buildingInfoRefs[1].current = feature.properties.euiValue;
        //     buildingInfoRefs[2].current = feature.properties.COMPLEX_NAME;
        //     buildingInfoRefs[3].current = feature.properties.EUI_QUALITY;
        //     buildingInfoRefs[4].current = feature.properties.buildingType;
        //     buildingInfoRefs[5].current = feature.properties.COOLING_LOOP;      
        // }

        buildingLayersRef.current.set(getBuildingName, layer);
        
        let sectionColor;
        
        // first test case is for buildings with no EUI data
        if (getEUIValue < 0) {
            sectionColor = (getMaxEUIValue > 0) ? EUIColors[6] : EUIColors[7];
            //console.log(getMaxEUIValue);
        } else if (getEUIValue / getMaxEUIValue < 0.2) {
            // green if the EUI value is very low
            sectionColor = EUIColors[0]; 
            
        } else if (getEUIValue / getMaxEUIValue < 0.4) {
            // light green if the EUI value is low
            sectionColor = EUIColors[1];
        } else if (getEUIValue / getMaxEUIValue < 0.6) {
            // yellow if the EUI value is medium
            sectionColor = EUIColors[2];
        } else if (getEUIValue / getMaxEUIValue < 0.8) {
            // orange if the EUI value is high
            sectionColor = EUIColors[3];
        } else if (getEUIValue / getMaxEUIValue <= 1) {
            // red if the EUI value is very high
            sectionColor = EUIColors[4];
        } else {
            // darker red if the EUI value is off the charts!
            sectionColor = EUIColors[5];
        } 
        feature.properties.EUI_QUALITY = sectionColor.quality;
        // feature.properties.EUI_Color = sectionColor.color;

        //console.log(feature.properties.NAME + "  " + EUIData.BuildingComplexName[id]);
        
            // No EUI and Extremely Poor EUI get same stroke color, the rest of buildings have black outline
            let shapeColor = sectionColor.color !== EUIColors[5].color ? sectionColor.color === "#806A5C" ? "#806A5C" : "rgb(0, 0, 0)" : EUIColors[5].color;
            //console.log(sectionColor.color !== EUIColors[5].color ? 0.1 : 100);
        //console.log("Previous:", prevFilteredOptions.current);
        //console.log("Current:", options);

            

            //let wasVisible = prevFilteredOptions.current.includes(getBuildingName); // 🔹 Previously visible?
            
            const activeIndex = euiStates.findIndex(state => state);
            const activeEUI = activeIndex !== -1 ? euiLabels[activeIndex] : null;

            // ⬇️ Use a Set for faster lookup
            const filteredSet = new Set(filteredOptions);
            
            const buildingEUI = layer.feature?.properties?.EUI_QUALITY;

            // the RHS of the && is needed so that the buildings with different EUI qualities have consistent opacity animations
            //let isVisible = filteredSet.has(getBuildingName) && (!activeEUI || buildingEUI === activeEUI); // 🔹 Currently visible?
            let isVisible = filteredSet.has(getBuildingName); // 🔹 Currently visible?

            // if (wasVisible !== isVisible || !isVisible) {
            // 🔥 Animate ONLY if visibility changed
            const lastOpacity = opacityMap.get(getBuildingName) || 1; // 🔍 Store previous opacity BEFORE updating, default to 1 if undefined
            const wasSemiTransparent = lastOpacity === 0.25; // ✅ Now correctly checks last known state

            //console.log(getBuildingName + ": " + wasSemiTransparent);
            const isTransitioning = transitioningBuildings.get(getBuildingName) || true;

            
            const buildingElement = layer.getElement();
            // runs only once?
            layer.on("add", () => {
                if (layer._path) {
                    layer._path.classList.add("smooth-transition");
                    // layer._path.style.fill = sectionColor.color;
                    // layer._path.style.stroke = shapeColor;
                    
                    // used for initial rendering of building colors
                    // if (boolyRef2.current) {
                    //     layer._path.style.fill = sectionColor.color;
                    //     layer._path.style.stroke = shapeColor;
                    //     // used setTimeout to prevent the fill and stroke from being set again after initial render
                    //     setTimeout(() => {
                    //         //prevent fill and stroke after initial render
                    //         boolyRef2.current = false;
                    //     }, 100);
                    // }
                    
                    layer._path.style.strokeWidth = sectionColor.color === EUIColors[5].color ? 2.5 : sectionColor.color === "#806A5C" ? 2 : 0.1;
                    layer._path.style.fillOpacity = isVisible ? 1 : 0.25;
                    layer._path.style.strokeOpacity = isVisible ? 1 : 0.25;
                    //layer._path.style.transition = "fill 0.3s ease, stroke 0.3s ease";
                }  
                // if (buildingElement) {
                //     if (isVisible) {
                //         buildingElement.classList.remove("unselectBuildingGroup");
                //         buildingElement.classList.add("selectBuildingGroup");
                //     } else {
                //         buildingElement.classList.remove("selectBuildingGroup");
                //         buildingElement.classList.add("unselectBuildingGroup");
                //     }
                    
                // }
            });

            // if (layer._path) {
            //     layer._path.classList.add("smooth-transition");
            //     layer._path.style.fillOpacity = isVisible ? 1 : 0.25;
            //     layer._path.style.strokeOpacity = isVisible ? 1 : 0.25;
            // }

            // layer.getElement()?.classList.add("fade-opacity");
            // layer.setStyle({ fillOpacity: 0.25, opacity: 0.25 });
            // console.log(layer.getElement()?.getAttribute("style"));

            const shouldAnimateToVisible = isVisible && (wasSemiTransparent || previousOpacity.get(getBuildingName) !== 1);

            // Collect changes in a temp map during the loop
            //const updatedOpacityMap = new Map(previousOpacity);
            // console.log(filterOptionsRef.current);

            if (isVisible) {
                if (layer._path) {
                    layer._path.classList.remove("building-dimmed");
                    layer._path.classList.add("building-visible");
                    
                }
            } else  {
                if (layer._path) {
                    layer._path.classList.remove("building-visible");
                    layer._path.classList.add("building-dimmed");
                    
                }
            }

            // if (isVisible) {
            //     if (wasSemiTransparent) {
            //         //console.log("lengend time");
            //         //animateOpacity(layer, 0.25, 1, getBuildingName); // 🔥 Ensure proper fade-in for previously invisible buildings
            //         //console.log(`[${getBuildingName}] wasSemiTransparent:`, wasSemiTransparent, '→ currentOpacity:', opacityMap.get(getBuildingName), '→ isVisible:', isVisible);
            //     } else {
            //         //console.log(getBuildingName + " " + isTransitioning);
            //         //console.log("Comparing:", getBuildingName, "vs", selectedBuildingRef.current);
                    
            //         const selected = selectedBuildingRef.current;
            //         const selectedLayer = buildingLayersRef.current.get(selected);
            //         //console.log(`[${selected}] opacity after selection:`, selectedLayer?.options?.opacity);

            //         buildingLayerRefs.current?.forEach((otherLayer) => {
            //             const otherBuildingName = otherLayer.feature.properties.COMPLEX_NAME;

            //             if (getBuildingName === otherBuildingName) {
            //                 //layer.setStyle({ fillOpacity: 1, opacity: 1 });
            //                 if (layer._path) {
            //                     layer._path.classList.add("smooth-transition");
            //                     layer._path.style.fillOpacity = 1;
            //                     layer._path.style.strokeOpacity = 1;
            //                 }
            //             } else {
            //                 //animateOpacity(layer, 0.25, 1, getBuildingName);
            //                 if (layer._path) {
            //                     layer._path.classList.add("smooth-transition");
            //                     layer._path.style.fillOpacity = isVisible ? 0.25 : 1;
            //                     layer._path.style.strokeOpacity = isVisible ? 0.25 : 1;
            //                 }
            //             }
            //         }); 
            //         // getBuildingName === selectedBuildingRef.current

            if (euiStatesRef.current.every(es => es === false) && loopStatesRef.current.every(ls => ls === false)) {

            }

            //         if (euiStates.every(es => es === false) && loopStates.every(ls => ls === false)) {
            //             //layer.setStyle({ fillOpacity: 1, opacity: 1 });
            //             if (layer._path) {
            //                 layer._path.classList.add("smooth-transition");
            //                 layer._path.style.fillOpacity = 1;
            //                 layer._path.style.strokeOpacity = 1;
            //             }
            //             //console.log("worked");

            //             //return;
            //         } else {
            //             // selectedBuildingRef.current = null;
            //             console.log(boolyRef.current);
            //             if (boolyRef.current) {
            //                 console.log("went thru: " + boolyRef.current);
            //                 //layer.setStyle({ fillOpacity: 1, opacity: 1 });
            //                 if (layer._path) {
            //                     layer._path.classList.add("smooth-transition");
            //                     layer._path.style.fillOpacity = 1;
            //                     layer._path.style.strokeOpacity = 1;
            //                 }
            //                 previousOpacity.set(getBuildingName, 1);
            //                 // boolyRef.current = false;
            //                 // boolyRef2.current = boolyRef.current;
            //             } else {
                            
            //                 if ((layer.feature.properties.COMPLEX_NAME === previouslySelectedBuildingRef.current && filteredOptions.length > 1)) {
            //                     //layer.setStyle({ fillOpacity: 1, opacity: 1 });
            //                     if (layer._path) {
            //                         layer._path.classList.add("smooth-transition");
            //                         layer._path.style.fillOpacity = 1;
            //                         layer._path.style.strokeOpacity = 1;
            //                     }
            //                     console.log("fin");
            //                 } else {
            //                     if (layer.feature.properties.COMPLEX_NAME === selectedBuildingRef.current) {
            //                         //console.log("Hello");
            //                         //layer.setStyle({ fillOpacity: 1, opacity: 1 });
            //                         if (layer._path) {
            //                             layer._path.classList.add("smooth-transition");
            //                             layer._path.style.fillOpacity = 1;
            //                             layer._path.style.strokeOpacity = 1;
            //                         }
            //                     } else {
            //                         console.log("The building selected: " + previouslySelectedBuildingRef.current);
                                        
            //                         //animateOpacity(layer, 0.25, 1, getBuildingName);
            //                         if (layer._path) {
            //                             layer._path.classList.add("smooth-transition");
            //                             layer._path.style.fillOpacity = isVisible ? 0.25 : 1;
            //                             layer._path.style.strokeOpacity = isVisible ? 0.25 : 1;
            //                         }
            //                     }
            //                 }
            //             }
                        
            //         }
                
            //         // layer.setStyle({ fillOpacity: 1, opacity: 1 });

            //         // buildingElement?.classList.remove("unselectBuildingGroup");
            //         // buildingElement?.classList.add("selectBuildingGroup"); euiStates.every((es) => es === false)

            //         // if (shouldAnimateToVisible)   {
            //         //     layer.setStyle({ fillOpacity: 1, opacity: 1 }); // ✅ Instantly set opacity for selected building
            //         // } else {
            //         //     animateOpacity(layer, 0.25, 1, getBuildingName);
            //         // }
            //     }
            //     previousOpacity.set(getBuildingName, 1); // 🔥 Update stored opacity AFTER checks
            //     setOpacityMap(previousOpacity);
            // } else {
            //     // to ensure the buildings that are already semi-transparent do not reanimate
            //     if (!wasSemiTransparent)   {
            //         //console.log("ya");
            //         //animateOpacity(layer, 1, 0.25, getBuildingName);
            //         if (layer._path) {
            //             layer._path.classList.add("smooth-transition");
            //             layer._path.style.fillOpacity = isVisible ? 1 : 0.25;
            //             layer._path.style.strokeOpacity = isVisible ? 1 : 0.25;
            //         }
            //     } else {
            //         //layer.setStyle({ fillOpacity: 0.25, opacity: 0.25 }); // ensures the stroke opacity is semi-transparent
            //         if (layer._path) {
            //             layer._path.classList.add("smooth-transition");
            //             layer._path.style.fillOpacity = 0.25;
            //             layer._path.style.strokeOpacity = 0.25;
            //         }
            //         // buildingElement?.classList.remove("selectBuildingGroup");
            //         // buildingElement?.classList.add("unselectBuildingGroup");
            //     }
            //     previousOpacity.set(getBuildingName, 0.25); // 🔥 Update stored opacity AFTER checks
            //     setOpacityMap(previousOpacity);
            // }
            //console.log(isExcellentEUI);
            
            const euiQuality = feature.properties.EUI_QUALITY;
            const buildingName = feature.properties.COMPLEX_NAME;

            buildingLayerRefs[euiQuality]?.current.set(buildingName, layer);

            //if (buildingName === "CASTLE MEMORIAL CARETAKERS COTTAGE")  console.log(euiQuality);
            
            // let euiStatez1 = isExcellentEUI;
            //console.log(filteredOptions);

            // buildingLayersRef.current.forEach((layer) => {
            //     const quality = layer.feature.properties.EUI_QUALITY;
            //     const buildingName = layer.feature.properties.BUILDING_NAME;

            //     const isVisible = quality === "Excellent EUI" ? isExcellentEUI : true;

            //     const prevOpacity = previousOpacity.get(buildingName) || 1;
            //     // Your existing opacity logic here
            //     if (isVisible) {
            //         if (prevOpacity < 1) {
            //             animateOpacity(layer, 0.25, 1, buildingName);
            //             previousOpacity.set(buildingName, 1);
            //         }//console.log("anybody home");
            //     } else {
                    
            //     }

            //     setOpacityMap(new Map(previousOpacity));
            // });

            

            // if (wasVisible && !isVisible) {
            //     animateOpacity(layer, 1, 0.25);
            // } else if (!wasVisible && isVisible) {
            //     if (options.length === 1) {
            //         layer.setStyle({ fillOpacity: 1 });
            //     } else {
            //         animateOpacity(layer, 0.25, 1);
            //     } 
            // } else {
            //     if (options.length === 1) {
            //         layer.setStyle({ fillOpacity: 1 });
            //     } else {
            //         animateOpacity(layer, 0.25, 1);
            //     }
                
            // }    

            // ✅ Update previous filter state for next comparison
            //prevFilteredOptions.current = filteredOptions;        
            let coolingLoopLabel;

            if (fiscalYear === 2023) {
                coolingLoopLabel = (getBuildingGroup !== "" && getBuildingGroup !== "B") ? ` (${getBuildingGroup})` : "";
            } else {
                coolingLoopLabel = (getBuildingGroup !== "") ? ` (${getBuildingGroup})` : "";
            }
            

            // sets the CSS styling for each building
            // color is the stroke color
            // const el = layer?._path;
            // if (el) {
            //     el.style.fill = sectionColor.color;
            //     el.style.stroke = shapeColor;
            //     el.style.strokeWidth = sectionColor.color !== EUIColors[5].color ? sectionColor.color === "#806A5C" ? 2 : 0.1 : 2.5;
            //     console.log("element accessed");
            // }
            const el = layer.getElement?.();
            // if (layer._path) {
            //     //el.removeAttribute('fill');              // prevent Leaflet from hijacking
            //     layer._path.classList.add('smooth-transition');        // enable CSS transition
            //     layer._path.style.fill = sectionColor.color;
            //     layer._path.style.stroke = shapeColor;
            //     //el.style.fill = '#cccccc';               // initial fill, safely overridden later
            // }
            
                // layer.setStyle({ 
                //                 fillColor: sectionColor.color, 
                //                 //fillOpacity: alpha, 
                //                 color: shapeColor,  //stroke color
                //                 //opacity: alpha, // stroke opacity
                //                 weight: sectionColor.color !== EUIColors[5].color ? sectionColor.color === "#806A5C" ? 2 : 0.1 : 2.5
                //             });
            
            
//             layer.setStyle({
//   color: '#333', // stroke
//   weight: 1.5,
//   opacity: 1,
//   fillOpacity: 1
// });

            // change/revert color when mouse hovered on a building
                layer.on({
                    mouseover: () => {

                        if (layer._path) {
                            // layer._path.classList.remove("scaleDown");
                            // layer._path.classList.add("scaleUp");
                            layer._path.style.transform = "scale(1.2)";
                            layer._path.style.stroke = "black";
                            layer._path.style.strokeWidth = "3px";
                            layer._path.style.transition = "stroke-width 0.4s ease, transform 0.4s ease";
                        }

                        // sets the style and displays building name
                        layer
                            // .setStyle({
                            //     fillColor: 'cyan',
                            //     //fillOpacity: alpha,
                            //     //opacity: alpha,
                            //     color: 'cyan',
                            // })
                            .bindTooltip(getBuildingName + coolingLoopLabel);
                            
                            buildingLayersRef.current.forEach((layer) => {
                                const el = layer?._path;

                                el?.addEventListener('mouseenter', () => {
                                    el?.classList?.remove('scaleDown');
                                    el?.classList?.add('scaleUp');
                                });

                                
                            });

                            
                    },
                    mouseout: () => {

                        if (layer._path) {
                            layer._path.style.transform = "scale(1)";
                            layer._path.style.stroke = shapeColor;
                            layer._path.style.strokeWidth = sectionColor.color !== EUIColors[5].color ? sectionColor.color === "#806A5C" ? 2 : 0.1 : 2.5;
                            layer._path.style.transition = "stroke-width 0.4s ease, transform 0.4s ease";
                        }

                        // layer
                        //     .setStyle({
                        //         fillColor: sectionColor.color,
                        //         //fillOpacity: alpha,
                        //         color: shapeColor,
                        //         //opacity: alpha,
                        //         weight: sectionColor.color !== EUIColors[5].color ? sectionColor.color === "#806A5C" ? 2 : 0.1 : 2.5
                        // });
                        buildingLayersRef.current.forEach((layer) => {
                            const el = layer?._path;

                            

                            el?.addEventListener('mouseleave', () => {
                                el?.classList?.remove('scaleUp');
                                el?.classList?.add('scaleDown');
                            });
                        });

                        // 
                    },
                    click: () => { 
                        // determine the EUI quality before updating the gauge chart
                        //let euiQuality = sectionColor.color === "rgb(0, 0, 0)" ? "Unknown EUI" : sectionColor.color === "#806A5C" ? "No EUI" : sectionColor.quality;
                        //let euiQuality = feature.properties.EUI_QUALITY;
                        //console.log(quality);
                        if (getEUIValue === null) {
                            //console.log("Null detected!"); // unnecessary?!
                            //eui = Math.floor(Math.random() * 50);
                            //updateEUI(eui);
                        } 

                        if (buildingInfoRefs) {
                            buildingInfoRefs[0].current = feature.properties.maxEUIValue;
                            buildingInfoRefs[1].current = feature.properties.euiValue;
                            buildingInfoRefs[2].current = feature.properties.COMPLEX_NAME;
                            buildingInfoRefs[3].current = feature.properties.EUI_QUALITY;
                            buildingInfoRefs[4].current = feature.properties.buildingType;
                            buildingInfoRefs[5].current = feature.properties.COOLING_LOOP;      
                        }
                        const selectedBuildingName = getBuildingName;
                        console.log("clicked building name: ", selectedBuildingName);
                        setSelectedName((prevName) => prevName === selectedBuildingName ? null : selectedBuildingName);
                        selectedBuildingRef.current = selectedName !== null ? selectedName : selectedBuildingRef.current;
                        // setTimeout(() => {
                            updateGaugeRangeAndValue(getMaxEUIValue, getEUIValue, getBuildingName, euiQuality, getBuildingType, getBuildingGroup);
                        // }, 100);

                        

                    //     const selectedBuildingName = getBuildingName;
                    //     const currentName = layer.feature.properties.COMPLEX_NAME;

                    //     const prevOpacity = previousOpacity.get(currentName) || 1;

                    //     if (currentName === selectedBuildingName) {
                    //         // Keep or animate the clicked building to full opacity
                    //         if (prevOpacity < 1) {
                    //             animateOpacity(layer, 0.25, 1, currentName);
                    //             previousOpacity.set(currentName, 1);
                    //         }
                    //     } else {
                    //         // Fade out others if they're currently at full opacity
                    //         if (prevOpacity === 1) {
                    //             animateOpacity(layer, 1, 0.25, currentName);
                    //             previousOpacity.set(currentName, 0.25);
                    //         }
                    //     }
                    
                    // used to stop opacity animation on other individual building (using useRef to get the live reference of isCooldown)
                    if (isCooldownRef.current) return;

                    

                    

                    // used to clear animation state, so reapplying animations will be more consistent
                    buildingLayersRef.current.forEach((layer) => {
                        const el = layer?._path;
                        el?.classList?.remove('scaleUp');
                        el?.classList?.remove('scaleDown'); // optional: depends on your exit styling
                    });

                    //console.log(polylineRef1.current);
                    console.log(filteredOptionsRef.current);
                    if (euiStates.every(es => es === false) && loopStates.every(ls => ls === false)) {
                        console.log("nothing selected in one of the two legends!");
                    }
                    console.log(selectedBuildingName, selectedLoopA([selectedBuildingName]), selectedLoopB([selectedBuildingName]));
                    //console.log(filterOptionsRef.current.includes(selectedBuildingName));
                    // used to affect the opacity animation of the cooling loops
                    

                    if (isCooldown3.current) {
                        if (!toastShown3.current) {
                                console.log("please show up");
                                toast.warn(<>Please wait a little.</>, 
                                                { 
                                                    position: 'top-center',
                                                    autoClose: 1000, 
                                                    onClose: () => {
                                                        toastShown3.current = false;
                                                    }
                                                });
                                                // toast shown status is set to true, false 1 second after it shows up
                                                toastShown3.current = true;
                                            
                                            return;
                            }
                    } else {
                        if (polylineRef1.current) {
                            applyOpacityTransition(polylineRef1.current, selectedLoopA([selectedBuildingName]));
                        } 
                        
                        if (polylineRef2.current) {
                            applyOpacityTransition(polylineRef2.current, selectedLoopC([selectedBuildingName]));
                            //console.log("C Loop:", polylineRef2.current)
                        } 

                        if (polylineRef3.current) {
                            applyOpacityTransition(polylineRef3.current, selectedLoopD([selectedBuildingName]));
                        } 

                        if (polylineRef4.current) {
                            applyOpacityTransition(polylineRef4.current, selectedLoopQUAD([selectedBuildingName]));
                        } 

                        if (polylineRef5.current) {
                            applyOpacityTransition(polylineRef5.current, selectedLoopB([selectedBuildingName]));
                        } 
                        if (layer._path) {
                            const isSelected = selectedName === getBuildingName;
                            const nothingSelected = selectedName === null;

                            layer._path.style.fillOpacity = isSelected ? 1 : nothingSelected ? 1 : 0.25;
                            layer._path.style.strokeOpacity = isSelected ? 1 : nothingSelected ? 1 : 0.25;
                            //previousOpacity.set(getBuildingName, isSelected ? 1 : nothingSelected ? 1 : 0.25);
                        }
                        isCooldown3.current = true;
                        toastShown3.current = false;
                        setTimeout(() => {
                            isCooldown3.current = false;
                            toastShown3.current = false;
                        }, 2000);
                    } 

                    

                    const isSameBuildingClicked = activeBuildingRef.current === selectedBuildingName;
                    // null if clicked on the same building, selectedBuildingName if clicked on a different building
                    let newToggledState = isSameBuildingClicked ? null : selectedBuildingName;
                    activeBuildingRef.current = newToggledState;

                    if (boolyRef3.current) {
                        newToggledState = selectedBuildingName;
                        activeBuildingRef.current = newToggledState;
                        boolyRef3.current = false;
                    } else {
                        newToggledState = isSameBuildingClicked ? null : selectedBuildingName;
                        activeBuildingRef.current = newToggledState;
                    }
                    console.log(newToggledState);
                    const selectedEUIIndex = euiStatesRef.current.findIndex(state => state);
                    const selectedLoopIndex = loopStatesRef.current.findIndex(state => state);
                    const euiLabels = [
                    "Excellent EUI", "Good EUI", "Average EUI", "Poor EUI",
                    "Very Poor EUI", "Extremely Poor EUI!", "Unknown EUI", "No EUI"
                    ];
                    const loopLabels = ["A", "C", "D", "QUAD", "B"];
                    console.log(selectedEUIIndex);
                    const activeEUI = selectedEUIIndex !== -1 ? euiLabels[selectedEUIIndex] : null;
                    const activeLoop = selectedLoopIndex !== -1 ? loopLabels[selectedLoopIndex] : null;

                    buildingLayersRef.current.forEach((layer, name) => {
                    const isTarget = name === newToggledState;
                    const isActiveEUI = layer.feature?.properties?.EUI_QUALITY === activeEUI;
                    const wasOpaque = previousOpacity.get(name) === 1;

                    let targetOpacity;

                    if (newToggledState === null) {
                        // Deselected a building
                        targetOpacity = activeEUI ? (isActiveEUI ? 1 : 0.25) : 1;
                    } else {
                        // Toggling on a building
                        targetOpacity = isTarget ? 1 : 0.25;
                    }

                    if (wasOpaque !== (targetOpacity === 1)) {
                        //animateOpacity(layer, wasOpaque ? 1 : 0.25, targetOpacity, name);
                        // if (layer._path) {
                        //     layer._path.style.fillOpacity = targetOpacity;
                        //     layer._path.style.strokeOpacity = targetOpacity;
                        // }
                        // previousOpacity.set(name, targetOpacity);
                    }
                    });

setOpacityMap(new Map(previousOpacity));
const polylines = [polylineRef1, polylineRef2, polylineRef3, polylineRef4, polylineRef5];
// Optionally reset polyline class states
if (newToggledState === null && !activeEUI && !activeLoop) {
    console.log(newToggledState);
  polylines.forEach(ref => {
    if (ref.current ) {
        console.log("cultpreir");
        ref.current.forEach(path => {
            path.classList.remove("building-dimmed");
            path.classList.add("building-visible");
        });
        
    }
    
  });
} else if (activeLoop) {
    if (newToggledState === null && filteredOptionsRef.current.every(bn => selectedLoopA([bn]))) {
        if (polylines[0].current) {
            polylines[0].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.every(bn => selectedLoopC([bn]))) {
        if (polylines[1].current) {
            polylines[1].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.every(bn => selectedLoopD([bn]))) {
        if (polylines[2].current) {
            polylines[2].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.every(bn => selectedLoopQUAD([bn]))) {
        if (polylines[3].current) {
            polylines[3].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.every(bn => selectedLoopB([bn]))) {
        if (polylines[4].current) {
            polylines[4].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    }
} else {
    if (newToggledState === null && filteredOptionsRef.current.some(bn => selectedLoopA([bn]))) {
        if (polylines[0].current) {
            polylines[0].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.some(bn => selectedLoopC([bn]))) {
        if (polylines[1].current) {
            polylines[1].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.some(bn => selectedLoopD([bn]))) {
        if (polylines[2].current) {
            polylines[2].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.some(bn => selectedLoopQUAD([bn]))) {
        if (polylines[3].current) {
            polylines[3].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    } 
    if (newToggledState === null && filteredOptionsRef.current.some(bn => selectedLoopB([bn]))) {
        if (polylines[4].current) {
            polylines[4].current.forEach(path => {
                path.classList.remove("building-dimmed");
                path.classList.add("building-visible");
            });
        }
    }
}


                    
}

                    // setOpacityMap(new Map(previousOpacity));
                        //filteredOptions = filteredOptions.filter(name => name === getBuildingName);
                    }
                );
            
            // 🔥 Ensure Leaflet properly refreshes layers (what does this mean?)
            layer._map?.invalidateSize();
        }
    

    return (
        // need to specify the map dimensions, or else the map will expand indefinitely (ARCGIS) 
        // or not show up (Leaflet)
        // for leaflet maps, id must be directly used, but useRef is also "indirectly" used to store the id reference from useLayoutEffect
        //<div id="campusMap" style={{width: "50vw", height: "50vh"}}></div>
        
        <>
            <MapContainer 
                //whenCreated={map => (mapRef.current = map)} // ✅ Stores map instance
                className='map-container'
                center={centerCoordinates} 
                zoom={zoomLevel} 
                zoomSnap={0.25}
                // zoomDelta={0.25}
                minZoom={15}
                maxBounds={
                    [
                        [21.2797972446035, -157.83953925554505], // bottom left corner (soutwest coordinates)
                        [21.313546124010898, -157.79680652726483] // top right corner (northeast cooridnates)
                    ]
                }
            >
                <TileLayer 
                    url='https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'  // osm texture 
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' // source of the tilelayer
                />
                <CenterMapButton center={centerCoordinates} zoom={zoomLevel} />
                {/* <MapClickHandler /> */}
                <GeoJSON
                    ref={geoJsonRef}
                    //style={{ transition: 'fill 1s ease, stroke 1s ease'}}
//                     style={(feature) => {
//     const name = feature.properties?.COMPLEX_NAME;
//     const eui = feature.properties?.euiValue;
//     const maxEUI = feature.properties?.maxEUIValue;
//     const sectionColor = getSectionColor(name, eui, maxEUI);
//     const shapeColor = getStrokeColor(name, sectionColor);
//     const isVisible = filteredOptions.includes(name);

//     return {
//       fillColor: sectionColor.color,
//       color: shapeColor,
//       fillOpacity: isVisible ? 1 : 0.25,
//       opacity: isVisible ? 1 : 0.25,
//       weight:
//         sectionColor.color !== EUIColors[5].color
//           ? sectionColor.color === "#806A5C"
//             ? 2
//             : 0.1
//           : 2.5,
//     };
//   }}
                    //key={filteredOptions.join(",")} // ✅ React re-renders when filteredOptions changes (need this for opacity animations) (euiStates.every(es => es === false)) ? filteredOptions.join(",") : (filteredOptionsRef.current.join(','))
                    data={combinedBuildingsData}
                    
                    // used to affect individual buildings
                    onEachFeature={(feature, layer) => onEachFeature2(feature, layer)} // onEachFeature2 isn't the reason why filteredOptions aren't updating in GeoJSON component

                />
                {/* <BuildingsLayer data={combinedBuildingsData} /> */}
                <CoolingLoops filteredOptions={filteredOptions} polylineRef1={polylineRef1} polylineRef2={polylineRef2} polylineRef3={polylineRef3} polylineRef4={polylineRef4} polylineRef5={polylineRef5} />
                
                <Legend euiStates={euiStates} setEUIStates={setEUIStates} loopStates={loopStates} setLoopStates={setLoopStates} setSelectedQuality={setSelectedQuality} boolyRef={boolyRef} />
                
            </MapContainer>
        
        </>
        // around 304 buildings
    );
}

function CenterMapButton({ center, zoom }) {
    const map = useMap();

    useEffect(() => {
        const centerMapButton = L.control({ position: "topleft" });

        centerMapButton.onAdd = () => {
            const button = L.DomUtil.create('button', 'leaflet-bar additional-buttons');
            button.innerHTML = '🏠';
            button.style.fontSize = '18px';
            // button.style.backgroundColor = 'white';
            // button.style.fontWeight = "bold";
            // button.style.marginBottom = "1000px";
            button.style.padding = '2px 2px'; // first is top and bottom, second is left and right
            button.onclick = () => {
                map.setView(center, zoom);
            };

            return button;
        }

        centerMapButton.addTo(map);

        return () => centerMapButton.remove();
    }, [map, center, zoom]);

    return null;
}

function BuildingsLayer({ data }) {
  const map = useMap(); // ✅ valid hook usage
  const previousColorsRef = useRef(new Map()); // ✅ also valid

  useEffect(() => {
    const geoJsonLayer = L.geoJson(data, {
      style: {
        fillColor: '#cccccc',
        color: '#333',
        weight: 1.5,
        opacity: 1,
        fillOpacity: 1
      },
      onEachFeature: (feature, layer) => {
        const el = layer.getElement?.();
        const name = feature?.properties?.COMPLEX_NAME;
        const eui = feature?.properties?.euiValue;
        const maxEUI = feature?.properties?.maxEUIValue;
        const newColor = getSectionColor(eui, maxEUI)?.color || '#cccccc';

        const prevColor =
          previousColorsRef.current.get(name) ||
          el?.style.fill ||
          '#cccccc';

        if (el) {
          el.removeAttribute('fill');
          el.classList.add('building-fill');
          el.style.fill = prevColor;
          void el.offsetWidth;
          el.style.fill = newColor;
          previousColorsRef.current.set(name, newColor);
        }
        console.log("BuildingsLayer triggered with new data");
        console.log(`${name}: ${prevColor} → ${newColor}`);

      }
    });

    geoJsonLayer.addTo(map);
    

    return () => {
      map.removeLayer(geoJsonLayer);
    };
  }, [data]);

  return null;
}


function MapClickHandler() {
    const validTags = ["DIV", "CANVAS", "PATH"];
    const map = useMap();
    useMapEvent({
        click: (e) => {
            if (validTags.includes(e.originalEvent.target.tagName))    {
                map.locate();
            }
        },
        locationfound: (location) => {
            console.log('location found:', location)
        },
    });
    return null;
}

// There seems to be no MultiPolygon component in react-leaflet :(
// perhaps the Polygon component also supports MultiPolygons

export default MapChart;